import { Component, Input } from '@angular/core';

@Component({
    selector: 'std-card',
    templateUrl: './card.component.html',
    styles: [],
    standalone: false
})
export class CardComponent {
  @Input() headerClass: string = '';
  @Input() cardClass: string = '';
  @Input() contentClass: string = '';
}
